import { Dataset } from 'src/app/modules/core/store/models/dataset.model';
import { View } from 'src/app/modules/management/store/workflow/workflow.model';
import { Layer } from '../../cop/models';
import { Document, RelatedDocumentsRequest } from 'src/app/modules/core/store/models/document.model';
import { DocumentQueryParams, FilterGroup } from 'src/app/modules/core/store/models';
import { ListsTableType } from './table-type.enum';

import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';

export const MAX_CARDS_TO_LOAD = 100;

export interface Card {
  layer?: Layer;
  document?: Document;
  dataset?: Dataset;
  workflowName?: string;
  workflowColor?: string;
  view?: View;
}

export interface CardView {
  htmlColorCode?: string;
  summaryName?: string;
  totalCount?: number;
  cards?: Card[];
  clusterId?: string;
  listType: ListsTableType;
}

export interface QueryParamsWithDocuments {
  query?: DocumentQueryParams;
  documents?: string[];
  clusterPosition?: any;
  requestedTotalCount?: number;
}

export interface ListQueryParams {
  [layerUId: string]: QueryParamsWithDocuments;
}

export interface ListQueryData {
  type: 'cluster' | 'layers' | 'summary' | 'closest-asset';
  headerLabel: string;
  colorCode?: string;
  sectionUId?: string;
  summaryName?: string;
  clusterId?: string;
  layerQueries: ListQueryParams;
  assetParams?: {
    locationGeoJson: Document;
    distanceGeoJson: string;
    withinMeters?: number;
    fromDate?: string;
    toDate?: string;
  };
  relatedDocumentsRequests?: RelatedDocumentsRequest[]
}

export interface ListQueryLayerDataUpdateTime {
  [layerUId: string]: any;
}

export interface ListQuery {
  updateDate: string;
  dataUpdateTime: ListQueryLayerDataUpdateTime;
  data: ListQueryData;
}

export const providerIconLookup = [
  { name: 'worldaware', img: ['https://files.topo.ai/partners/logos/Crisis24.svg'] },
  { name: 'crisis24', img: ['https://files.topo.ai/partners/logos/Crisis24.svg'] },
  { name: 'factal', img: ['https://files.topo.ai/partners/logos/Factal.svg'] },
  { name: 'liferaft', img: ['https://files.topo.ai/partners/logos/LifeRaft.svg'] },
  { name: 'citizen', img: ['https://files.topo.ai/partners/logos/Citizen.svg'] },
  { name: 'notFound', img: ['icon-alert_status', '#ffffff', '#7257ff'] },
  { name: 'risk advisory', img: ['icon-alert_status', '#ffffff', '#7257ff'] },
  { name: 'earthquake', img: ['icon-alert_status', '#ffffff', '#7257ff'] },
  { name: 'topoone earthquakes', img: [apiBaseUrl + '/v1/meta/markers/earthquake-magnitude-3/B46923/0/0/normal/earthquake.svg'] },
  { name: 'weather alert', img: ['icon-alert_status', '#ffffff', '#7257ff'] },
  { name: 'wildfire', img: ['icon-alert_status', '#ffffff', '#7257ff'] },
  { name: 'isos', img: ['https://files.topo.ai/partners/logos/ISOS.svg'] },
  { name: 'nc4', img: ['https://files.topo.ai/partners/logos/NC4.svg'] },
  { name: 'dsx', img: ['icon-alert_status', '#ffffff', '#7257ff'] },
  { name: 'control risks', img: ['https://files.topo.ai/partners/logos/Control%20Risks.svg'] },
  { name: 'dataminr', img: ['https://files.topo.ai/partners/logos/Dataminr.svg'] },
  { name: 'dragonfly', img: ['https://files.topo.ai/partners/logos/Dragonfly.svg'] },
  { name: 'poweroutageus', img: ['https://files.topo.ai/partners/logos/PowerOutageUS.svg'] },
  { name: 'poweroutage.us', img: [apiBaseUrl + '/v1/meta/markers/power-outage-small/CCEAFF/0/0/normal/power.png'] },
  { name: 'samdesk', img: ['https://files.topo.ai/partners/logos/Samdesk.svg'] },
  { name: 'skopenow', img: ['https://files.topo.ai/partners/logos/Skopenow.svg'] },
  { name: 'spycloud', img: ['https://files.topo.ai/partners/logos/SpyCloud.svg'] },
  { name: 'tam-c', img: ['https://files.topo.ai/partners/logos/TAM-C.png'] },
  { name: 'titan hst', img: ['https://files.topo.ai/partners/logos/Titan%20HST.svg'] },
  { name: 'max security', img: ['https://files.topo.ai/partners/logos/Max%20Security.svg'] },
  { name: 'avigilon acm', img: ['/assets/images/avigilon.svg', '#ffffff', '#7257ff'] },
  { name: 'envoy', img: ['icon-alert_status', '#ffffff', '#7257ff'] },
  { name: 'praedictix email', img: ['https://files.topo.ai/partners/logos/Praedictix.svg'] },
  { name: 'mitkat', img: ['https://files.topo.ai/partners/logos/mitkat.svg'] },
  { name: 'incident', img: ['icon-briefcase_solid', '#ffffff', '#ee6400'] },
  { name: 'topoone tropical-cyclones', img: [apiBaseUrl + '/v1/meta/markers/tropical-cyclones/CCEAFF/0/0/normal/tropical-cyclones.png'] },
  { name: 'onsolve', img: [apiBaseUrl + '/v1/meta/markers/on-solve/000000/0/0/normal/icon.svg'] },
  { name: 'vizzion', img: ['icon-small_solid_car', '#3A8E06', '#ffffff'] },
  { name: 'facility', img: ['icon-building', '#ffffff', '#7257ff'] },
  { name: 'person', img: ['icon-small_solid_person', '#ffffff', '#000000'] },
  { name: 'liveview', img: [apiBaseUrl + '/v1/meta/markers/lvt/00A19B/0/0/normal/lvt.svg', '#00A19B', '#FFFFFF'] },
  { name: 'genea', img: ['/assets/images/genea.svg', '#ffffff', '#7257ff'] },
  { name: 'ccure', img: ['/assets/images/c-cure.jpg', '#ffffff', '#7257ff'] }
];
